import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

import { Grid, Avatar, Button } from '@mui/material'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';

import ReactLoading from 'react-loading';

import { login, getUser, getUserAgency, getAllAgencies } from '../API';

import { useTranslation } from "react-i18next";

import Cookies from "js-cookie";

const Login = () => {

  const [isCookieSet, setCookie] = useState(Cookies.get("cookieConsent"));
  const [showConsent, setShowConsent] = useState(false);

  const [t] = useTranslation('common');

  const navigate = useNavigate();

  const avatarStyle = { backgroundColor: '#4d0077' }
  const btnstyle = { margin: '8px 0' }

  const [user, setUser] = useState('');
  const [pwd, setPwd] = useState('');

  const [agencies, setAgencies] = useState('');
  const [agency, setAgency] = useState('rtl');
  const [errMsg, setErrMsg] = useState('');
  const [success, setSuccess] = useState(false);

  const [refreshKey, setRefreshKey] = useState(0);

  const [loading, setLoading] = useState(0);

  useEffect(() => {

    getUser()
      .then((response) => {
        if (response.user && response.user.login !== 'admin') {
          setUser(response.user);
          sessionStorage.setItem('authed', JSON.stringify(true));
          getUserAgency()
            .then((response) => {
              setAgency(response);
            }).then(() => {
              setSuccess(true);
              setLoading(0);
              navigate("/home");
            })
        }
      })

    getAllAgencies()
      .then(response => {
        setAgencies(response);
      })

  }, []);


  useEffect(() => {
    setErrMsg('');
  }, [user, pwd]);


  // Function to get existing consent cookie
  useEffect(() => {

    if (!Cookies.get("cookieConsent")) {
      setShowConsent(true)
    }

  }, [])


  const handleSubmit = async (e) => {

    setLoading(1);
    e.preventDefault();
    let setLogin = await login(user, pwd);

    if (setLogin.status !== 200) {
      setErrMsg(1)
      setLoading(0);
    } else {

      setSuccess(true);
      setUser('');
      setPwd('');
      sessionStorage.setItem('authed', JSON.stringify(true));
      location.reload();

    }
  }

  // Function to handle accepting cookies
  const handleAcceptCookies = () => {
    Cookies.set("cookieConsent", true, { expires: 365 });
    setCookie(true);
    setShowConsent(false);
  };


  // Function to handle rejecting cookies
  // const handleRejectCookies = () => {
  //   Cookies.remove("cookieConsent");
  //   setCookie(false);
  // };


  return user && success == true ? (

    <>

      <div></div>

    </>
  ) :
    (
      <>

        {loading == 0 ? '' :
          <div className="ponctualitespinner">
            <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
          </div>}

        <div className="login-page">
          <div className="login-page__container">
            <div className="login-card shadow p-3 bg-body rounded">
              <Grid align='center'>
                  <Avatar style={avatarStyle}><LockOutlinedIcon /></Avatar>
                  <h2 className="pt-2 pb-2">Bus RT Insights</h2>
                </Grid>
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="pb-2">
                    <input
                      id="username"
                      className="form-control form-control-lg"
                      type="text"
                      onChange={(e) => { setUser(e.target.value) }}
                      placeholder={t("login.user")}
                      aria-label="usager"
                      value={user}
                    />
                  </div>
                  <div className="pt-2 pb-2">
                    <input
                      id="password"
                      className="form-control form-control-lg"
                      type="password"
                      onChange={(e) => { setPwd(e.target.value) }}
                      placeholder={t("login.pass")}
                      value={pwd}
                    />
                  </div>
                  <Button type='submit' color='primary' variant="contained" style={btnstyle} fullWidth>{t('login.connect')}</Button>
                </form>
                <div className="alert alert-danger mt-3 mb-0" role="alert" style={{ visibility: errMsg !== '' ? "visible" : "hidden" }}>
                  {t("login.error")}
                </div>
            </div>
          </div>
        </div>

        {showConsent == true ?
          <div className="login-cookie-banner">
            <div className="login-cookie-banner__content">
              <p className="login-cookie-banner__text">{t('login.cookie')}</p>
              <button type="button" className="btn btn-light login-cookie-banner__btn" onClick={handleAcceptCookies}>
                {t('login.accept')}
              </button>
            </div>
          </div> : ''}

      </>
    );


}

export default Login;